<template>
  <div class="page-sidebar sidebar">
    <div
      style="position: relative; overflow: hidden; width: auto; height: 100%;"
    >
      <div
        v-slimscroll="slimScrollOptions"
        class="page-sidebar-inner slimscroll"
      >
        <ul class="menu accordion-menu">
          <li
            v-for="menuItem in menuItems"
            class="droplink"
            v-if="current_user"
          >
            <router-link
              :to="menuItem.url"
              v-b-toggle="'collapse' + menuItem.id"
              variant="primary"
            >
              <span class="menu-icon">
                <i :class="'fa ' + menuItem.icon" aria-hidden="true"></i>
              </span>
              <p>{{ menuItem.name }}</p>
            </router-link>

            <b-collapse v-if="menuItem.childs" :id="'collapse' + menuItem.id">
              <ul class="sub-menu">
                <li v-for="childItem in menuItem.childs">
                  <router-link :to="childItem.url">{{
                    childItem.name
                  }}</router-link>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>
      </div>
    </div>
    <!-- Page Sidebar Inner -->
  </div>
  <!-- Page Sidebar -->
</template>

<script>
import Vue from "vue";
import VueSlimScroll from "vue-slimscroll";
Vue.use(VueSlimScroll);

export default {
  name: "SideBar",
  data() {
    return {
      current_user: null,
      slimScrollOptions: {
        height: "100%",
        size: 0
      }
    };
  },
  computed: {
    menuItems: function() {
      if (!this.current_user) return [];

      var items = [
        {
          id: 1,
          name: this.$i18n.t("message.Абоненты"),
          url: "/accounts",
          icon: "fa-address-book",
          permissions: ["accounts:read", "accounts:read_any"]
        },
        {
          id: 30,
          name: this.$i18n.t("message.Видеотека"),
          icon: "fa-cubes",
          url: "#",
          permissions: [
            "vod_movies:fully_manage",
            "vod_dictionaries:fully_manage",
            "vod_dictionaries:read"
          ],
          childs: [
            {
              id: 31,
              name: this.$i18n.t("message.Видеотека"),
              url: "/vod_movies"
            },
            {
              id: 32,
              name: this.$i18n.t("message.Видеотека_-_Пакеты"),
              url: "/vod_packages"
            },
            {
              id: 33,
              name: this.$i18n.t("message.Видеотека_-_Жанры"),
              url: "/vod_genres"
            },
            {
              id: 34,
              name: this.$i18n.t("message.Видеотека_-_Сервисы"),
              url: "/vod_services"
            }
          ]
        },
        {
          id: 7,
          name: this.$i18n.t("message.Пакеты"),
          url: "packages",
          icon: "fa-tags",
          permissions: ["packages:fully_manage", "packages:read"]
        },
        {
          id: 5,
          name: this.$i18n.t("message.Каналы"),
          url: "/channels",
          icon: "fa-desktop",
          permissions: ["channels:fully_manage", "channels:read"]
        },
        {
          id: 6,
          name: this.$i18n.t("message.Категории"),
          url: "/categories",
          icon: "fa-folder",
          permissions: ["categories:fully_manage", "categories:read"]
        },
        {
          id: 5,
          name: this.$i18n.t("message.Сервисы"),
          url: "/services",
          icon: "fa-cogs",
          permissions: ["services:fully_manage"]
        },
        {
          id: 5,
          name: this.$i18n.t("message.Колокейшены"),
          url: "/colocations",
          icon: "fa-project-diagram",
          permissions: [
            "colocations:fully_manage",
            "colocations:set_spare_enabled"
          ]
        },
        {
          id: 10,
          name: this.$i18n.t("message.Источники_импорта"),
          url: "/sources",
          icon: "fa-stream",
          permissions: ["epgsources:fully_manage"]
        },
        {
          id: 100,
          name: this.$i18n.t("message.Apks"),
          permissions: ["apks:fully_manage"],
          url: "/apks",
          icon: "fa-stream"
        },
        {
          id: 110,
          name: this.$i18n.t("message.Статистика"),
          url: "#",
          permissions: [
            "statistics:fully_manage",
            "statistics:logrequests_fully_manage",
            "statistics:logsessions_fully_manage"
          ],
          icon: "fa-stream",
          childs: [
            {
              id: 111,
              name: this.$i18n.t("message.Статистика_Dashboard"),
              url: "/statistics"
            },
            {
              id: 112,
              name: this.$i18n.t("message.Статистика_Дневной_отчет"),
              url: "/StatisticsChannelsBySessionsByDate"
            },
            {
              id: 113,
              name: this.$i18n.t("message.Статистика_Лог_запросов"),
              url: "/logrequests"
            },
            {
              id: 113,
              name: this.$i18n.t("message.Статистика_Лог_сессий"),
              url: "/logsessions"
            }
          ]
        },
        {
          id: 20,
          name: this.$i18n.t("message.Администрирование"),
          icon: "fa-cubes",
          url: "#",
          permissions: ["admin:fully_manage"],
          childs: [
            {
              id: 21,
              name: this.$i18n.t("message.Пользователи"),
              url: "/Users"
            },
            {
              id: 22,
              name: this.$i18n.t("message.Роли"),
              url: "/Roles"
            }
          ]
        }
      ];

      var filtered_items = [];
      items.forEach(item => {
        if (
          !item.permissions ||
          this.current_user.permissions.filter(value =>
            item.permissions.includes(value)
          ).length
        )
          filtered_items.push(item);
      });
      return filtered_items;
    }
  },
  mounted: function() {
    this.current_user = this.$storage.get("current_user");
  },
  components: {
    VueSlimScroll
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Nav/SideBar.vue